import React, { useState } from "react";
import apiClient, { initializeApiClient } from "../../api/apiClient";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
import useApi from "../../hooks/useApi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/counterSlice";

export const Restpassword = () => {
  const dispatch = useDispatch();
  const navgater = useNavigate();
  const [data, setdata] = useState({
    old_password: "",
    new_password1: "",
    new_password2: "",
  });

  const farmdata = (key, value) => {
    setdata({ ...data, [key]: value });
  };
  initializeApiClient();
  const { request, loading, error } = useApi((data) =>
    apiClient.post("/authentication/password-change/", data)
  );

  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      if (data.new_password1 !== data.new_password2) {
        toast.error("New passwords do not match");
        return;
      }

      const result = await request(data);

      toast.success(result.data.detail || "Password updated successfully");
      dispatch(logout());
      navgater("/signin");
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.old_password) {
          toast.error(error.response.data.old_password[0]);
        } else {
          Object.entries(error.response.data).forEach(([key, value]) => {
            toast.error(`${key}: ${value[0]}`);
          });
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  return (
    <div>
      <div>
        {/* Signup button popup */}
        <div className="main_2 d-flex justify-content-center align-items-center py-5">
          <div className="signin-box p-2 rounded-3 col-md-3">
            <h2 className="text-center mt-1 mb-1"> Password</h2>
            <div className="horizontal-line mx-auto mb-4"></div>

            <form
              onSubmit={handlesubmit}
              className="d-flex flex-column justify-conetent-center mx-5  "
            >
              <TextField
                onChange={(e) => farmdata("old_password", e.target.value)}
                id="outlined-basic"
                label="Old Password"
                variant="outlined"
              />
              <TextField
                onChange={(e) => farmdata("new_password1", e.target.value)}
                className="my-3"
                id="outlined-basic"
                label="New Password"
                variant="outlined"
              />
              <TextField
                onChange={(e) => farmdata("new_password2", e.target.value)}
                id="outlined-basic"
                label="confirm  New Password"
                variant="outlined"
              />

              <button
                className="btn text-light mb-3 mt-4 mx-auto rounded-4 py-1"
                style={{ backgroundColor: "#015A96", width: "170px" }}
              >
                {" "}
                Update{" "}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
